export const status = {
  submitted: "Pending",
  cancelled: "Cancelled",
  inProgress: "InProgress",
  complete: "Complete",
};
